theme.Zoom = function() {
    var selectors2 = {
        imageZoom: "[data-image-zoom]"
    }
      , classes = {
        zoomImg: "zoomImg"
    }
      , attributes = {
        imageZoomTarget: "data-image-zoom-target"
    };
    function Zoom(container) {
        this.container = container,
        this.cache = {},
        this.url = container.dataset.zoom,
        this._cacheSelectors(),
        this.cache.sourceImage && this._duplicateImage()
    }
    return Zoom.prototype = Object.assign({}, Zoom.prototype, {
        _cacheSelectors: function() {
            this.cache = {
                sourceImage: this.container.querySelector(selectors2.imageZoom)
            }
        },
        _init: function() {
            var targetWidth = this.cache.targetImage.width
              , targetHeight = this.cache.targetImage.height;
            this.cache.sourceImage === this.cache.targetImage ? (this.sourceWidth = targetWidth,
            this.sourceHeight = targetHeight) : (this.sourceWidth = this.cache.sourceImage.width,
            this.sourceHeight = this.cache.sourceImage.height),
            this.xRatio = (this.cache.sourceImage.width - targetWidth) / this.sourceWidth,
            this.yRatio = (this.cache.sourceImage.height - targetHeight) / this.sourceHeight
        },
        _start: function(e) {
            this._init(),
            this._move(e)
        },
        _stop: function() {
            this.cache.targetImage.style.opacity = 0
        },
        _setTopLeftMaxValues: function(top, left) {
            return {
                left: Math.max(Math.min(left, this.sourceWidth), 0),
                top: Math.max(Math.min(top, this.sourceHeight), 0)
            }
        },
        _move: function(e) {
            var left = e.pageX - (this.cache.sourceImage.getBoundingClientRect().left + window.scrollX)
              , top = e.pageY - (this.cache.sourceImage.getBoundingClientRect().top + window.scrollY)
              , position = this._setTopLeftMaxValues(top, left);
            top = position.top,
            left = position.left,
            this.cache.targetImage.style.left = -(left * -this.xRatio) + "px",
            this.cache.targetImage.style.top = -(top * -this.yRatio) + "px",
            this.cache.targetImage.style.opacity = 1
        },
        _duplicateImage: function() {
            this._loadImage().then(function(image) {
                this.cache.targetImage = image,
                image.style.width = image.width + "px",
                image.style.height = image.height + "px",
                image.style.position = "absolute",
                image.style.maxWidth = "none",
                image.style.maxHeight = "none",
                image.style.opacity = 0,
                image.style.border = "none",
                image.style.left = 0,
                image.style.top = 0,
                this.container.appendChild(image),
                this._init(),
                this._start = this._start.bind(this),
                this._stop = this._stop.bind(this),
                this._move = this._move.bind(this),
                this.container.addEventListener("mouseenter", this._start),
                this.container.addEventListener("mouseleave", this._stop),
                this.container.addEventListener("mousemove", this._move),
                this.container.style.position = "relative",
                this.container.style.overflow = "hidden"
            }
            .bind(this)).catch(function(error) {
                console.warn("Error fetching image", error)
            })
        },
        _loadImage: function() {
            return new Promise(function(resolve, reject) {
                var image = new Image;
                image.setAttribute("role", "presentation"),
                image.setAttribute(attributes.imageZoomTarget, !0),
                image.classList.add(classes.zoomImg),
                image.src = this.url,
                image.addEventListener("load", function() {
                    resolve(image)
                }),
                image.addEventListener("error", function(error) {
                    reject(error)
                })
            }
            .bind(this))
        },
        unload: function() {
            var targetImage = this.container.querySelector("[" + attributes.imageZoomTarget + "]");
            targetImage && targetImage.remove(),
            this.container.removeEventListener("mouseenter", this._start),
            this.container.removeEventListener("mouseleave", this._stop),
            this.container.removeEventListener("mousemove", this._move)
        }
    }),
    Zoom
}()

document.addEventListener("DOMContentLoaded", function() {
  if (typeof theme !== 'undefined' && theme.Zoom) {
    // Select all zoomable product images
    const zoomWrappers = document.querySelectorAll("[data-image-zoom-wrapper]");

    zoomWrappers.forEach(wrapper => {
      new theme.Zoom(wrapper); // Initialize zoom for each image container
    });
  } else {
    console.warn("Zoom script not found or theme.Zoom not defined");
  }
});